import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthorizationInterceptorService } from './authorization-interceptor.service';

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptorService, multi: true },
  ]
